var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlStatement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18036_11046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5732 8.68125C35.565 6.66457 32.8595 5.49546 30.0146 5.41508C27.1697 5.3347 24.4025 6.34916 22.2837 8.24924C20.1648 10.1493 18.856 12.7901 18.6271 15.6269C18.3982 18.4637 19.2667 21.2801 21.0535 23.4953L7.01562 37.5266L12.1191 42.6933L13.8813 40.9311L10.4801 37.5299L11.6594 36.3573L15.0606 39.7585L16.8228 37.9996L13.4116 34.5984L22.8124 25.2709C25.0366 27.0325 27.8503 27.877 30.677 27.6313C33.5037 27.3856 36.1294 26.0683 38.0163 23.9494C39.9032 21.8304 40.9084 19.0701 40.8261 16.2339C40.7437 13.3978 39.5799 10.7005 37.5732 8.69458V8.68125ZM29.7148 7.90174C30.8492 7.89671 31.9731 8.11904 33.0201 8.5556C34.0672 8.99215 35.0161 9.63408 35.811 10.4435C37.2079 11.853 38.0733 13.703 38.26 15.6787C38.4467 17.6544 37.9432 19.6338 36.835 21.2801C35.7269 22.9263 34.0826 24.1378 32.1819 24.7085C30.2812 25.2791 28.2415 25.1736 26.4098 24.4099C24.5782 23.6462 23.0677 22.2715 22.1353 20.5196C21.2029 18.7678 20.9063 16.7471 21.2959 14.8012C21.6854 12.8553 22.7371 11.1045 24.272 9.84658C25.807 8.58869 27.7303 7.90144 29.7148 7.90174Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V47.97H47.97V0H0ZM45.9346 45.9246H2.05538V2.04539H45.9346V45.9246Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18036_11046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlStatement);
export default __webpack_public_path__ + "static/media/control-statement.da9759d15037200447d3d45d498903df.svg";
export { ForwardRef as ReactComponent };